import { render, staticRenderFns } from "./integration-settings-tester-btn.vue?vue&type=template&id=0b102c74"
import script from "./integration-settings-tester-btn.vue?vue&type=script&lang=js"
export * from "./integration-settings-tester-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports